import {
  updateResourceState,
  normalizeResourceState,
  createResourceReducer,
  RESOURCE
} from '@unicus/react-ui-kit';

import {
  MEDICALRECORDSECTION,
  MEDICALRECORDSECTION_SORTING
} from './medicalRecordSectionActions';

const medicalRecordSectionReducer = createResourceReducer(
  MEDICALRECORDSECTION,
  [],
  {
    [MEDICALRECORDSECTION_SORTING](state, action) {
      const newState = normalizeResourceState(state, action.resource);

      return updateResourceState(newState, action, RESOURCE, () => ({
        items: action.payload
      }));
    }
  }
);

export default medicalRecordSectionReducer;
